// src/config/product.js
//
// Pass 86R — ONE trusted product-identity seam (name / public origin / transactional sender). These are NOT secrets, but
// they ARE deliberate config — never hard-coded in a dozen places, and never derived from a request body or
// window.location. Build-time env (REACT_APP_*) overrides the default; the default is the safe current truth.
//
// Product rename Motus → Voletus (brand only — the underlying Firebase/GCP project id `sports-video-anaylsis` and all
// data/tenant ids are UNCHANGED legacy infrastructure identifiers).
//
// STAGED CUTOVER: PUBLIC_APP_URL defaults to the working Firebase Hosting origin so that NO invite/app link is dead while
// the `app.voletus.com` custom domain is still being provisioned (DNS/TLS). Once the custom domain is proven live, set
// REACT_APP_PUBLIC_APP_URL=https://app.voletus.com in the production build config and redeploy — no code change required.

function envStr(key, fallback) {
  try {
    if (typeof process !== 'undefined' && process.env && typeof process.env[key] === 'string' && process.env[key].trim()) {
      return process.env[key].trim();
    }
  } catch (_) { /* env not available (some runtimes) — fall through to default */ }
  return fallback;
}

export const PRODUCT_NAME = envStr('REACT_APP_PRODUCT_NAME', 'Voletus');
// STAGE B (Pass 86C): the custom domain https://app.voletus.com is now connected to Firebase Hosting with a valid TLS
// certificate and voletus.com 301-redirects to it (independently verified), so it is the CANONICAL app origin and the safe
// default. The legacy Firebase .web.app host still serves the same app as a fallback; REACT_APP_PUBLIC_APP_URL can still
// override if ever needed. Stage A (Firebase-host default) is over.
export const PUBLIC_APP_URL = envStr('REACT_APP_PUBLIC_APP_URL', 'https://app.voletus.com');
export const EMAIL_FROM_NAME = envStr('REACT_APP_EMAIL_FROM_NAME', 'Voletus');
export const EMAIL_FROM_ADDRESS = envStr('REACT_APP_EMAIL_FROM_ADDRESS', 'hello@voletus.com');

const product = { PRODUCT_NAME, PUBLIC_APP_URL, EMAIL_FROM_NAME, EMAIL_FROM_ADDRESS };
export default product;
